import 'bootstrap/dist/css/bootstrap.min.css';
import Navigation from "../components/navigation";
import Header from "../components/header";
import StandardButton from "../components/basic/StandardButton";
import {
    encryptAES256,
    generateRandomKeyForAES256
} from "../business/encryption/aes";
import StateManager from "../redux/StateManager";
import {createFile, downloadFile} from "../utils/utils";
import {toast, ToastContainer} from "react-toastify";
import {calculateBoxDownloadSize, savePasswordRecovery} from "../server-calls";
import {useEffect, useRef, useState} from "react";
import {getEndpoints} from "../utils/server-endpoints"
import axios from "axios";
import StandardDropDown from "../components/basic/StandardDropDown";
import {listUserBoxes} from "../server-calls/index"
import {updateCache} from "../idb";
import "react-toastify/dist/ReactToastify.css";

export default function Settings() {

    const TOAST_CONTAINER_ID= "settings-toast-container"

    const navigationRef = useRef()

    function startSocket() {
        navigationRef.current?.handleSocket()
    }

    useEffect(() => {
        listUserBoxes(StateManager.getToken()).then((data) => {
            let boxes = []
            data.forEach(box => {
                boxes.push({text: box.name, value: box.name})
            })
            setBoxes(boxes)
            setMailbox(boxes[0].value)
        }).catch((error) => {
            console.error(error)
        })
        startSocket()
    }, []);

    const [boxes, setBoxes] = useState([])
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0)
    let [mailbox, setMailbox] = useState("")

    const handleMailbox = (e) => {
        setMailbox(e.target.value)
    }

    const generateRecoveryString = async () => {
        toast.loading(`Generating recovery string`, {containerId: TOAST_CONTAINER_ID});
        let key = generateRandomKeyForAES256(32)
        let string = `${StateManager.getPassphrase()}___SEP___${StateManager.getPrivateKey()}`
        let encryptedString = encryptAES256(string, key)
        await savePasswordRecovery({recoveryString: encryptedString}, StateManager.getToken())
        downloadRecoveryString(key)
        toast.dismiss({containerId: TOAST_CONTAINER_ID});
        toast.success("Recovery credentials update success.", {containerId: TOAST_CONTAINER_ID});

    }

    const downloadRecoveryString = (recoveryString) => {
        let fileUrl = createFile([recoveryString])
        downloadFile(fileUrl, `${StateManager.getUserEmail()}_privmail_recovery.txt`)
    }


    const handleExport = async () => {
        setLoading(true)
        let totalSizeOfBox = await calculateBoxDownloadSize(mailbox, StateManager.getToken())
        const token = StateManager.getToken(); // ✅ Get auth token
        setLoading(true);
        setProgress(0);

        try {
            let endpoint = getEndpoints().exportMailbox.url
            endpoint = endpoint.replace("BOX_NAME_HERE", mailbox)
            const res = await axios.get(endpoint, {
                method: "GET",
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                onDownloadProgress: (progressEvent) => {
                    let loaded = progressEvent.loaded
                    let percentage = Math.round((loaded / totalSizeOfBox) * 100)
                    setProgress(percentage)
                },
            });

            setProgress(99);

            const blob = new Blob([res.data], {type: "text/plain;charset=utf-8"});
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `${mailbox}.box`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setProgress(100);
        } catch (err) {
            alert("Download failed: " + err.message);
            setProgress(0);
        } finally {
            setLoading(false);
        }
    };

    function exportCache() {

    }

    function importCache() {

    }

    return (
        <>
            <Header></Header>
            <div className="container-fluid" style={{height: '95vh'}}>
                <div style={{height: "95vh"}} className="row">
                    <div className="col-md-1 col-lg-1 col-xl-1 p-0">
                        <Navigation ref={navigationRef} handlerFunction={updateCache}/>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-6 p-10">
                        <div className="row">
                            <div className="col-md-6 col-lg-6 col-xl-6 p-10">
                                <h4>Password Recovery</h4><br></br>
                                <p>You can backup your passphrase and your private key. For situations where you lose
                                    one
                                    of<br></br>
                                    them. Your content will never travel to backend. We are gonna encrypt your
                                    credentials <br></br> using AES256 and download the key for you.</p><br></br>
                                <StandardButton onClick={generateRecoveryString} innerText={"Save Credentials"}/>
                            </div>
                        </div>
                        <br></br><br></br>
                        <div className="row">
                            <div className="col-md-6 col-lg-6 col-xl-6 p-10">
                                <h4>Export Boxes</h4><br></br>
                                <StandardDropDown options={boxes} onChange={handleMailbox}
                                                  placeholder={"Select a box"}/><br></br><br></br>
                                {!loading && (<StandardButton innerText={"Export"} onClick={handleExport}/>)}
                                <br></br>
                                {loading && (
                                    <><p>Download in progress, please wait....</p>
                                        <div className="progress">
                                            <div className="progress-bar progress-bar-striped progress-bar-animated"
                                                 role="progressbar"
                                                 aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100"
                                                 style={{width: progress + "%"}}>
                                                {progress}%
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                        <br></br><br></br>
                        <div className="row">
                            <div className="col-md-6 col-lg-6 col-xl-6 p-10">
                                <h4>Export Cache</h4><br></br>

                                <StandardButton innerText={"Export Cache"} onClick={exportCache}/>


                            </div>
                        </div>
                        <br></br><br></br>
                        <div className="row">
                            <div className="col-md-6 col-lg-6 col-xl-6 p-10">
                                <h4>Import Cache</h4><br></br>

                                <StandardButton innerText={"Import Cache"} onClick={importCache}/>


                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <ToastContainer containerId={TOAST_CONTAINER_ID}/>
        </>
    );
}